const openPicksShop = place => {
  const shopsURL = `https://picks.fun/shops?place=${place}`
  window.open(shopsURL)
}

export default openPicksShop
